import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid} from '@material-ui/core';
import Header from 'Components/common/Header';
import {T} from 'Actions/translate';
import ProductManagementSCCard from 'Components/inventoryQuery/ProductManagementSCCard';
import LoadingIcon from 'Components/icons/LoadingIcon';
import {getAdventProductOfSCList} from 'Actions/host';
import logo from 'Images/logo_bottom.png';

class AdventProductsSCList extends Component {
    state = {
        listLoaded: true,
    };

    componentDidMount() {
        this.props.getAdventProductOfSCList().then(() => {
            this.hideloading();
        });
    }

    hideloading = () => {
        this.setState({
            listLoaded: false,
        });
    };

    chooseSC = (scDetails) => {
        this.goToSCDetails(scDetails);
    };

    goToSCDetails = (scDetails) => {
        this.props.history.push('/AdventProductDetails', {scId: scDetails.id});
    };
    goBack = () => this.props.history.push('/userCenter');

    render() {
        const {listLoaded} = this.state;
        const {adventProductsSCList} = this.props;

        return (
            <div className="replenishment-mgmt" testid="sc-hold-products-page">
                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <Grid
                        className="page-title-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="page-title" item xs={11}>
                            <span>{T('supplyCenter')}</span>
                        </Grid>
                    </Grid>
                </Header>

                {listLoaded ? (
                    <LoadingIcon className="circle-animation" />
                ) : (
                    <Grid
                        className="note-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid item xs={11}>
                            {adventProductsSCList &&
                                adventProductsSCList.map((item) => (
                                    <ProductManagementSCCard
                                        key={item.number}
                                        scDetails={item}
                                        chooseSC={this.chooseSC}
                                    />
                                ))}
                            <div className="abyss-sect">
                                <div className="hr-sect">
                                    <span className="finish-line">
                                        {T('already_in_the_bottom')}
                                    </span>
                                </div>
                                <div className="image-sect">
                                    <img
                                        src={logo}
                                        className="logo"
                                        alt="tfc logo"
                                    />
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host} = state;

    return {
        adventProductsSCList: host.adventProductsSCList,
    };
};

const mapDispatchToProps = {
    getAdventProductOfSCList,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AdventProductsSCList);
